import { useRouter } from 'next/router';

import { getFormattedDate } from 'utils/date';
import { SidebarLink } from 'components/sidebar-link/sidebar-link';

import styles from './accordion-list.module.scss';

export interface IAccordionSidebarItemProps {
	slug?: string;
	files: string[];
	path?: string;
}

export const AccordionSidebarItem = ({
	slug,
	files,
	path = 'besluiten'
}: IAccordionSidebarItemProps): React.JSX.Element => {
	const { locale } = useRouter();

	return (
		<ul>
			{files.map((fileName) => (
				<li key={fileName} className={slug === fileName ? styles.active : undefined}>
					<SidebarLink
						title={getFormattedDate(new Date(fileName), 'dd MMMM yyyy', locale)}
						href={`/${path}/${fileName}`}
					/>
				</li>
			))}
		</ul>
	);
};

export default AccordionSidebarItem;
